import { AwardIcon, BriefcaseIcon, CircleCheckIcon, SettingsIcon } from "lucide-react";

export const trustFeatures = [
  {
    icon: CircleCheckIcon,
    title: { en: "Reliable Service", es: "Servicio Confiable" },
    text: { en: "You can count on us every time. Background-checked, professional team.", es: "Puede contar con nosotros siempre. Equipo profesional con verificación de antecedentes." },
  },
  {
    icon: BriefcaseIcon,
    title: { en: "Trained Staff", es: "Personal Capacitado" },
    text: { en: "Qualified and extensively trained professionals ready for any task.", es: "Profesionales calificados y ampliamente capacitados, listos para cualquier tarea." },
  },
  {
    icon: SettingsIcon,
    title: { en: "Flexible Solutions", es: "Soluciones Flexibles" },
    text: { en: "Custom solutions tailored to your business needs and schedule.", es: "Soluciones a la medida de las necesidades y el horario de su negocio." },
  },
  {
    icon: AwardIcon,
    title: { en: "Quality You Can Trust", es: "Calidad de Confianza" },
    text: { en: "Excellence in every service we provide. Your satisfaction guaranteed.", es: "Excelencia en cada servicio que brindamos. Su satisfacción garantizada." },
  },
];
